import React, { useState, useEffect, Fragment } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { Form, Col } from 'react-bootstrap';
import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import If from '../../../../components/If';
import Loading from '../../../../components/Loading';
import Button from '../../../../components/Button';
import EditButton from '../../../../components/EditButton';
import SearchEmpty from '../../../../components/SearchEmpty';
import api from '../../../../services/api';
import { EventsResult } from '../../../../models/models';
import { statusToText } from '../../../../functions/formatStatus';
import '../../styles_list.css';

export default function Events ()
{
	const history = useHistory();
	const [events, setEvents] = useState<Array<EventsResult>>([]);
	const [loading, setLoading] = useState<boolean>(true);
	const [loadingSearch, setLoadingSearch] = useState<boolean>(false);
	const [error, setError] = useState<boolean>(false);
	const [emptySearch, setEmptySearch] = useState<boolean>(false);

	const { register, handleSubmit, getValues } = useForm({
		defaultValues: { name: '', active: true },
	})

	useEffect(() => {
		const getEvents = async () => {
			try {
				const { data } = await api.get<EventsResult[]>(`api/v1/cultivares/Evento/obterporfiltro?&Ativo=${getValues('active')}`);

				setEvents(data);
			} catch (error:any) {
				setError(true);
			}
			setLoading(false);
		}
		getEvents();
	}, [getValues]);


	const search = async () => {
		setError(false);
		setLoadingSearch(true);

		try {
			const { data } = await api.get<EventsResult[]>(`api/v1/cultivares/Evento/obterporfiltro?Ativo=${getValues('active')}&NomeEvento=${getValues('name')}`);

			if (data.length) {
				setEvents(data);
				setEmptySearch(false);
			} else {
				setEmptySearch(true);
			}
		} catch (error:any) {
			setError(true);
		}
		setLoadingSearch(false);
	}

	const actions = ({ data }: any) => (
		<Fragment>
			<EditButton
				onClick={() => {
					history.push({
						pathname: '/editar/evento',
						state: {
							id: data.id
						}
					})
				}}
			/>
		</Fragment>
	)

	return <div className="container-custom-search">
		<div className="top-content">
			<h3>Consulta de eventos</h3>
		</div>
		<div className="row-buttons">
			<Button
				onClick={() => history.push('/cadastrar/eventos')}
				contained
				title="Adicionar"
				type="button"
			/>
		</div>
		<br />
		<Form onSubmit={handleSubmit(search)}>
			<Form.Row className="row-custom">
				<Form.Group as={Col} md={8}>
					<Form.Label>Nome do Evento</Form.Label>
					<Form.Control
						ref={register}
						name="name"
						maxLength={100}
						autoComplete="off"
					/>
				</Form.Group>
				<Form.Group>
					<Form.Label />
					<Form.Check
						type="checkbox"
						ref={register}
						name="active"
						label="Ativos"
					/>
				</Form.Group>
				<span className="filter-btn">
					<Button
						title="Buscar"
						type="submit"
						contained
						isLoading={loadingSearch}
					/>
				</span>
			</Form.Row>
		</Form>
		<If condition={emptySearch}>
			<div className="div-empty">
				<SearchEmpty />
			</div>
		</If>
		<If condition={!loading && !error && !emptySearch && events.length}>
			<div className="search-content">
				<div className="ag-theme-alpine" style={{ height: "70vh", width: '100%' }}>
					<AgGridReact
						rowData={events}
						defaultColDef={{ flex: 1, sortable: true, resizable: true }}
						pagination
						paginationPageSize={10}
						frameworkComponents={{
							actions: actions,
						}}
					>
						<AgGridColumn
							headerName='Nome do evento'
							field="nomeEvento"
							cellStyle={{
								alignItems: 'center'
							}}
							wrapText={true}
							autoHeight
						/>
						<AgGridColumn
							headerName="Status"
							field='ativo'
							valueFormatter={({ data }: any) => statusToText(data.ativo)}
							cellStyle={{
								alignItems: 'center'
							}}
						/>
						<AgGridColumn
							field='Ações'
							cellRenderer='actions'
							cellStyle={{
								alignItems: 'center'
							}}
						/>
					</AgGridReact>
				</div>
			</div>
		</If>
		<If condition={loading}>
			<div className="loading-container">
				<Loading />
			</div>
		</If>
	</div>;
}